import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import Navbar from "../components/Navbar";
import SeccionServicios from "../components/Servicios/SeccionServicios";
import Seo from "../components/Seo";

export function Servicios() {

  const { t } = useTranslation();
  const pathByLang = t("seo.services.pathByLang", { returnObjects: true });

  useEffect(() => {
    localStorage.setItem("colorFooter", "white");
    localStorage.setItem("colorNav", "color");
  }, []);

  return (
    <div>
      <Seo pageKey="services" pathByLang={pathByLang} />
      <Navbar />
      <SeccionServicios />
    </div>
  );
}
